import React from 'react';
import { CTAButton } from './CTAButton';
export function ClosingSection() {
  return <section className="bg-dark py-24 px-4" data-id="element-27">
      <div className="max-w-[900px] mx-auto flex flex-col items-center text-center" data-id="element-28">
        <h2 className="text-4xl md:text-5xl font-bold text-white mb-10" data-id="element-29">
          Ya sabes que algo no está bien.
        </h2>

        <div className="text-xl md:text-2xl text-white mb-12 space-y-4 font-medium" data-id="element-30">
          <p data-id="element-31">No porque te falte capacidad,</p>
          <p data-id="element-32">sino porque estás sosteniendo demasiado.</p>
          <p data-id="element-33">Puedes seguir igual y repetir el mismo mes.</p>
          <p data-id="element-34">O puedes hacer un ajuste hoy.</p>
          <br data-id="element-35" />
          <p data-id="element-36">90 minutos.</p>
          <p data-id="element-37">$15.</p>
          <p data-id="element-38">Una nueva forma de operar tu negocio.</p>
        </div>

        <CTAButton className="w-full md:w-auto text-xl py-5 px-12" data-id="element-39">
          AJUSTAR MI NIVEL AHORA
        </CTAButton>
      </div>
    </section>;
}